import { HTTP_METHODS } from "@src/constants/http-methods.constant";
import { INTERNAL_API_ENDPOINTS } from "@src/constants/internal-api-endpoints-constants";
import type { FreezeAppointmentRequest } from "@src/interfaces/freeze-appointment.interface";
import type { ApiCallConfig } from "@src/utils/api-client";

/**
 * Builds the callApi config for the freeze-appointment endpoint.
 * Produces the exact query-param shape the upstream expects (snake_case, stringified)
 * so the API route can forward req.body directly as queryParams.
 */
export function buildFreezeAppointmentConfig(
  request: FreezeAppointmentRequest,
  signal?: AbortSignal,
): ApiCallConfig {
  return {
    method: HTTP_METHODS.POST,
    endpoint: INTERNAL_API_ENDPOINTS.FREEZE_APPOINTMENT,
    body: {
      user_uuid: request.userUuid,
      practice_id: String(request.practiceId),
      appointment_id: request.appointmentIds.join(","),
      freeze_appointment: String(request.freezeAppointment ?? true),
    } as Record<string, unknown>,
    ...(signal ? { signal } : {}),
  };
}
